
    import '/home/runner/work/GPT-Vis/GPT-Vis/src/PathMap/index.md?watch=parent';
    export const demoIndex = {
  ids: ["pathmap-demo-default","pathmap-demo-line","pathmap-demo-markdown"],
  getter: () => import(/* webpackChunkName: "meta__PathMap" */'/home/runner/work/GPT-Vis/GPT-Vis/src/PathMap/index.md?type=demo')
};